import { render, staticRenderFns } from "./SexagesimalFormatTable.vue?vue&type=template&id=de1be1c8&scoped=true"
import script from "./SexagesimalFormatTable.vue?vue&type=script&lang=ts"
export * from "./SexagesimalFormatTable.vue?vue&type=script&lang=ts"
import style0 from "./SexagesimalFormatTable.vue?vue&type=style&index=0&id=de1be1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1be1c8",
  null
  
)

export default component.exports